import clsx from "clsx";
import { FunctionComponent } from "react";

import { type Campaign } from "@voxmedia/duet-context/context/campaign-context";

import * as styles from "./BrandedContentSponsor.css";

interface Props {
  className?: string;
  imageClassName?: string;
  textClassName?: string;
  campaign?: Campaign;
}

const BrandedContentSponsor: FunctionComponent<Props> = ({
  campaign,
  className,
  imageClassName = "",
  textClassName = "",
}) => {
  const preamble = campaign?.advertiserPreamble || "Advertisement Content from";

  if (!campaign) {
    return null;
  }

  const logoAltText = campaign.advertiserName
    ? `${campaign.advertiserName} logo`
    : "Campaign Logo";

  return (
    <div className={clsx(styles.content, className)}>
      <div className={clsx(styles.text, textClassName)}>
        {campaign.campaignDisclaimer ? (
          <span className={styles.disclaimerCTA}>{preamble}</span>
        ) : (
          <span>{preamble}</span>
        )}
        {campaign.campaignDisclaimer && (
          <div className={styles.disclaimerBox}>
            {campaign.campaignDisclaimer}
          </div>
        )}
      </div>

      <div className={clsx(styles.imageContainer, imageClassName)}>
        <a
          href={
            campaign.advertiserClickthroughUrl
              ? campaign.advertiserClickthroughUrl
              : "/"
          }
        >
          {campaign.campaignAdvertiserDarkImage ||
          campaign.campaignAdvertiserLightImage ? (
            <div className={styles.logoContainer}>
              {/* We must use an img element here because the logos come in at different aspect
            ratios and we dont have its dimensions */}
              <img
                className={clsx(styles.logo, styles.darkLogo)}
                src={
                  campaign.campaignAdvertiserDarkImage ||
                  campaign.campaignAdvertiserLightImage
                }
                alt={logoAltText}
              />
              <img
                className={clsx(styles.logo, styles.lightLogo)}
                src={
                  campaign.campaignAdvertiserLightImage ||
                  campaign.campaignAdvertiserDarkImage
                }
                alt={logoAltText}
              />
            </div>
          ) : (
            <span className={styles.advertiserName}>
              {campaign.advertiserName}
            </span>
          )}
        </a>
      </div>
    </div>
  );
};

export default BrandedContentSponsor;
